<template>
  <aha-tooltip
    interactive
    arrow
    maxWidth="264px"
    ref="tooltip"
    v-bind="mergedAttrs"
  >
    <section class="aha-tooltip" :class="{'show-close-button': showClose,...paddingClass, 'light': isLightTheme}">
      <section class="top-section">
        <section class="text-content">
          <section v-if="title" class="tooltip-title">
            <slot v-if="showIcon" name="icon">
              <aha-icon
                name="information"
                width="20"
                height="19"
                viewBox="0 0 14 15"
              />
            </slot>
            <span>{{ title }}</span>
          </section>
          <section class="tooltip-text" v-if="text" v-html="text" />
          <section v-if="$slots['custom-content']" class="tooltip-custom-content">
            <slot
              name="custom-content"
            />
          </section>
        </section>
        <aha-icon
          v-if="showClose"
          @click="close()"
          class="close-button"
          name="close"
          height="20"
          width="20"
          viewBox="0 0 24 24"
        />
      </section>
      <img
        v-if="imgSrc"
        class="tooltip-image"
        :src="imgSrc"
      >
      <aha-button
        v-if="buttonText"
        variant="success"
        @click="click"
      >
        {{ buttonText }}
      </aha-button>
    </section>
  </aha-tooltip>
</template>
<script>
export default {
  props: {
    to: {
      type: String,
      default: '',
    },
    trigger: {
      type: String,
      default: 'mouseenter focus',
    },
    title: {
      type: String,
      default: '',
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    text: {
      type: String,
      default: '',
    },
    imgSrc: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: '',
    },
    showClose: {
      type: Boolean,
      default: false,
    },
    hideTooltipAfterClick: {
      type: Boolean,
      default: true,
    },
    theme: {
      type: String,
      default: 'dark',
    },
    placement: {
      type: String,
      default: 'top',
    },
    narrowPadding: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    mergedAttrs() {
      return {
        to: this.to,
        trigger: this.trigger,
        title: this.title,
        showIcon: this.showIcon,
        text: this.text,
        imgSrc: this.imgSrc,
        buttonText: this.buttonText,
        showClose: this.showClose,
        hideTooltipAfterClick: this.hideTooltipAfterClick,
        theme: this.theme,
        placement: this.placement,
        ...this.$attrs,
      }
    },
    paddingClass() {
      const fullPaddingCssClass = 'full-padding'
      const narrowPaddingCssClass = 'narrow-padding'
      const narrowPaddingCondition = !this.buttonText && !this.title && !this.imgSrc
      return {
        [narrowPaddingCssClass]: this.narrowPadding || narrowPaddingCondition,
        [fullPaddingCssClass]: !this.narrowPadding && !narrowPaddingCondition,
      }
    },
    isLightTheme() {
      return this.theme === 'light'
    },
  },
  methods: {
    show() {
      const tooltipInstance = this.$refs.tooltip ? this.$refs.tooltip.tip : null
      if (!tooltipInstance) return
      tooltipInstance.show()
    },
    hide() {
      const tooltipInstance = this.$refs.tooltip ? this.$refs.tooltip.tip : null
      if (!tooltipInstance) return
      tooltipInstance.hide()
    },
    close() {
      this.hide()
      this.$emit('close-click')
    },
    click() {
      this.$emit('click')
      if (this.hideTooltipAfterClick) {
        this.hide()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
    .close-button {
        cursor: pointer;
        padding: 2px;
        box-sizing: content-box;
        color: #B5B5B5;
        transition: color 200ms;

        &:hover {
            color: #348EF6;
        }
    }
    .aha-tooltip {
        --max-width: 264px;
        --max-image-height: 132px;
        --max-content: var(--max-width);
        // --min-width: var(--max-width);
        --gap: 0.5rem;
        // --min-height: 120px;

        &.show-close-button {
          --max-content: 200px;
        }

        &.light {
          background-color: #ffffff;
          border-radius: 4px;
        }

        & .top-section {
          display: flex;
          justify-content: space-between;
        }

        & .text-content {
          display: flex;
          flex-direction: column;
          gap: var(--gap);
          max-width: var(--max-content);
        }

        display: flex;
        flex-direction: column;
        gap: var(--gap);
        margin: -5px -9px;
        max-width: var(--max-width);
        // min-height: var(--min-height);
        // min-width: var(--max-width);
        text-align: left;

        &.full-padding {
            padding: 1rem;
        }

        &.narrow-padding {
            padding: 0.5rem;
        }

        & button {
            width: fit-content;
        }

        & .tooltip-title {
            @apply font-bold;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            & > svg {
                min-width: fit-content;
            }
        }

        & .tooltip-image {
            width: 100%;
            max-height: var(--max-image-height);
        }
    }
</style>
